<template>
  <div class="search-content" :style="{top: GLOBAL.currentEnvironment ? '0' : ''}">
    <!-- <Navbar :appTitle="title" :rtitle="rtitle" :rname="rname" /> -->
    <Search ref="topSearch" class="search" placeholder="商品名称|商品编号|订单编号|销售订单" :isAdd="false" :isScreen="false" :isType="false"></Search>
    <div class="formgroup">
      <span class="title">承诺交期</span>
      <van-field :is-link="!promiseDateRead" readonly name="picker" @click="promiseDateStartVisible = true" placeholder="请选择" v-model="promiseDateRead">
        <div slot="right-icon" v-show="!!promiseDateRead" @click.stop="cancelPromiseStartTime"><van-icon name="clear" size="0.16rem" /></div>
      </van-field>
      <div class="bottomLine"></div>
      <span class="title">订单提交时间</span>
      <van-field :is-link="!createdTimeRead" readonly name="picker" v-model="createdTimeRead" @click="createdTimeBeginVisible = true" placeholder="请选择">
        <div slot="right-icon" v-show="!!createdTimeRead" @click.stop="cancelCreatedStartTime"><img src="~@/assets/img/filedClear.png" alt="" style="width:0.16rem"></div>
      </van-field>
      <div class="bottomLine"></div>
      <span class="title">订单提交人</span>
      <van-field :is-link="!createdByName" readonly name="picker" v-model="createdByName" @click="ddthrVisible = true" placeholder="请选择">
        <div slot="right-icon" v-show="!!createdByName" @click.stop="confirmDdtjr('','',true)"><img src="~@/assets/img/filedClear.png" alt="" style="width:0.16rem"></div>
      </van-field>
      <div class="bottomLine"></div>
      <span class="title">销售合同编号</span>
      <van-field v-model="params.contractCode" label="" placeholder="请输入"/>
      <div class="bottomLine"></div>
      <span class="title">商品规格</span>
      <van-field v-model="params.spec" label="" placeholder="请输入"/>
    </div>
    <div class="search-bottom">
      <span class="btncancel" @click="cancel">重置</span>
      <span class="btnconfirm" @click="confirm">确定</span>
    </div>

    <!--承诺交期开始时间 -->
    <van-popup v-model="promiseDateStartVisible" position="bottom" :close-on-click-overlay='false'>
      <van-datetime-picker @confirm="confirmPromiseStartTime" @cancel="cancelPromiseStartTime" type="date" title="承诺交期开始时间" v-model="minDate1"
        :formatter="formatter" />
    </van-popup>
    <!--承诺交期结束时间 -->
    <van-popup v-model="promiseDateEndVisible" position="bottom" :close-on-click-overlay='false'>
      <van-datetime-picker @confirm="confirmPromiseEndTime" @cancel="cancelPromiseEndTime" type="date" title="承诺交期结束时间" :min-date="promiseEndMinDate"
        :formatter="formatter" />
    </van-popup>

    <!--订单提交开始时间 -->
    <van-popup v-model="createdTimeBeginVisible" position="bottom" :close-on-click-overlay='false'>
      <van-datetime-picker @confirm="confirmCreatedStartTime" @cancel="cancelCreatedStartTime" type="date" title="订单提交开始时间" v-model="minDate1"
        :formatter="formatter" />
    </van-popup>
    <!--订单提交结束时间 -->
    <van-popup v-model="createdTimeEndVisible" position="bottom" :close-on-click-overlay='false'>
      <van-datetime-picker @confirm="confirmCreatedEndTime" @cancel="cancelCreatedEndTime" type="date" title="订单提交结束时间" :min-date="createEndMinDate"
        :formatter="formatter" />
    </van-popup>
    <contact-pickers :visible="fzrVisible" :max="5" @closePicker="fzrVisible = false" @confirm="confirmChooseUsers">
    </contact-pickers>
    <contact-pickers :visible="ddthrVisible" :max="5" @closePicker="ddthrVisible = false" @confirm="confirmDdtjr">
    </contact-pickers>
  </div>
</template>

<script>
const formP = {
  status: 0,
  chargeUserId: "", //生产负责人ID
  craftName: "",
  contractCode: "",
  createdBy: "",
  promiseDateBegin: "",
  promiseDateEnd: "",
  createdTimeBegin: "",
  createdTimeEnd: "",
};
import Navbar from "@/components/navBar/navBar_right";
import ContactPickers from "@/components/choiceuse/ContactPickers";
import upload from "@/components/upload/upload";
import moment from "moment";
import Search from "@/components/search";
export default {
  name: "search",
  components: { Navbar, ContactPickers, upload, Search },
  data() {
    return {
      title: this.$route.meta.title,
      fzrVisible: false,
      ddthrVisible: false,
      promiseDateStartVisible: false,
      promiseDateEndVisible: false,
      createdTimeBeginVisible: false,
      createdTimeEndVisible: false,
      fzrName: "", //生产负责人
      createdByName: "", //订单提交人
      rtitle: "",
      rname: "", //search
      minDate1: new Date(),
      minDate2: new Date(),
      createEndMinDate: new Date(2020, 1, 1),
      promiseEndMinDate: new Date(2020, 1, 1),
      maxDate: new Date(2025, 10, 1),
      params: Object.assign({}, formP),
      createdTimeRead: "",
      promiseDateRead: "",
    };
  },
  props: {
    keyword: {
      type: String,
      default: "",
    },
  },
  watch: {
    keyword(newVal) {
      this.$refs.topSearch.value = newVal;
    },
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    fileChange(ids) {
      console.log("父组件" + ids);
    },
    // 选择承诺交期开始时间
    confirmPromiseStartTime(date) {
      this.promiseEndMinDate = date;
      this.params.promiseDateBegin = moment(date).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      this.params.promiseDateEnd = ""; // 切换开始时间后直接置空结束时间重新选择
      this.promiseDateStartVisible = false;
      this.promiseDateEndVisible = true;
      this.promiseDateRead = moment(date).format('YYYY-MM-DD')
    },
    // 取消承诺交期开始时间
    cancelPromiseStartTime() {
      this.params.promiseDateBegin = "";
      this.params.promiseDateEnd = "";
      this.promiseDateRead = "";
      this.promiseDateStartVisible = false;
    },
    // 选择承诺交期结束时间
    confirmPromiseEndTime(date) {
      this.params.promiseDateEnd = moment(date).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      this.promiseDateRead = this.promiseDateRead + '~' + moment(date).format('YYYY-MM-DD')
      this.promiseDateEndVisible = false;
    },
    // 取消承诺交期结束时间
    cancelPromiseEndTime() {
      this.params.promiseDateBegin = "";
      this.params.promiseDateEnd = "";
      this.promiseDateRead = "";
      this.promiseDateEndVisible = false;
    },
    // 选择订单提交开始时间
    confirmCreatedStartTime(date) {
      this.createEndMinDate = date;
      this.params.createdTimeBegin = moment(date).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      this.params.createdTimeEnd = ""; // 切换开始时间后直接置空结束时间重新选择
      this.createdTimeBeginVisible = false;
      this.createdTimeEndVisible = true;
      this.createdTimeRead = moment(date).format('YYYY-MM-DD');
    },
    // 取消订单提交开始时间
    cancelCreatedStartTime() {
      this.params.createdTimeBegin = "";
      this.params.createdTimeEnd = "";
      this.createdTimeRead = "";
      this.createdTimeBeginVisible = false;
    },
    // 选择订单提交结束时间
    confirmCreatedEndTime(date) {
      this.params.createdTimeEnd = moment(date).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      this.createdTimeRead = this.createdTimeRead + '~' + moment(date).format('YYYY-MM-DD')
      this.createdTimeEndVisible = false;
    },
    // 取消订单提交结束时间
    cancelCreatedEndTime() {
      this.params.createdTimeBegin = "";
      this.params.createdTimeEnd = "";
      this.createdTimeRead = "";
      this.createdTimeEndVisible = false;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      if (type === "hour") {
        return val + "时";
      }
      if (type === "minute") {
        return val + "分";
      }
      return val;
    },
    chooseUser() {
      this.fzrVisible = true;
    },
    confirmChooseUsers(val, selectedList, judge) {
      this.params.chargeUserId = "";
      this.fzrName = "";
      if (judge) {
        this.fzrVisible = false;
        return;
      }
      this.params.chargeUserId = val ? val : ""; //人员id
      let arr = [];
      if (selectedList) {
        selectedList.forEach((item) => {
          arr.push(item.realname);
        });
      }
      this.fzrName = arr.join(",");
      this.fzrVisible = false;
    },
    confirmDdtjr(val, selectedList, judge) {
      this.params.createdBy = "";
      this.createdByName = "";
      if (judge) {
        this.ddthrVisible = false;
        return;
      }
      this.params.createdBy = val ? val : ""; //人员id
      let arr = [];
      if (selectedList) {
        selectedList.forEach((item) => {
          arr.push(item.realname);
        });
      }
      this.createdByName = arr.join(",");
      this.ddthrVisible = false;
    },
    cancel() {
      this.createdByName = "";
      this.createdTimeRead = "";
      this.promiseDateRead = "";
      this.$refs.topSearch.value = "";
      this.minDate1 = new Date()
      this.minDate2 = new Date()
      this.params = Object.assign({}, formP);
      // this.$emit("resetCategory");
    },
    confirm() {
      var keyword = this.$refs.topSearch.value
      this.$emit("getCategory", this.params, keyword);
    },
  },
};
</script>
<style lang="scss" scoped>
.search-content {
  //  padding-bottom: 0.5rem;
  position: fixed;
  top: 70px;
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
  z-index: 99;
  .formgroup {
    // height: calc(100vh - 1.11rem);
    padding-bottom: 106px;
    overflow-y: scroll;
    background: #ffffff;
    // padding: 0 0.16rem;
    margin-top: 20px;
    margin-bottom: 40px;
    padding-top: 20px;

    .title {
      width: 106px;
      height: 28px;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #191f25;
      line-height: 10px;
      margin-left: 32px;
    }
  }
  .search-bottom {
    height: 100px;
    width: 100%;
    background: #ffffff;
    // background: red;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0px;
    padding: 22px;
    font-size: 32px;
    .btnconfirm {
      width: 344px;
      height: 78px;
      background: #1890ff;
      color: #fff;
      border-radius: 6px;
      text-align: center;
      line-height: 78px;
    }
    .btncancel {
      width: 344px;
      height: 78px;
      background: #F6F6F6;
      color: #191F25;
      // border: 0.01px solid rgba(25, 31, 37, 0.12);
      border-radius: 6px;
      text-align: center;
      line-height: 78px;
    }
  }
}
.bottomLine {
  height: 2px;
  background-color: #f0f0f0;
  margin: 0 32px 28px;
}
</style>